/**
* @Component Name: DepositInfoComponent
* @Module: Home
* @Module Functionality : To display the customer line deposit information
* @Creation Date: August 12,2017
* @Author: sbaireddy
* @Version: 1.0
*/
import { Component, Input, OnInit, OnDestroy, OnChanges } from '@angular/core';

import { IDeposit } from '../../shared/modal/common';
import { Customer } from '../../shared/modal/customer';
import * as Constants from '../../shared/constants';
import { SharedService } from '../../shared/shared.service';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector: 'deposit-info-cmp',
   // moduleId: module.id,
    templateUrl: 'deposit-info.component.html',
    styleUrls: ['deposit-info.component.css']
})

export class DepositInfoComponent implements OnInit, OnDestroy, OnChanges {
    private COMPONENT_NAME: string = 'DepositInfoComponent';
    Math: any;
    @Input() customer: Customer;
    isDepositLinesDisplayed = [];
    isDepositLinesDisplayedMI = [];
    storeId: number;
    rtStoreId: number = Constants.STORE_ID_RT;
    GSMDeposits: IDeposit[];
    MBBDeposits: IDeposit[];

    constructor(
        public sharedService: SharedService,
        public customerService: CustomerService) {
        this.Math = Math;
    }

    /**
   * This function is used to initialize the directive/component after Angular
   * first displays the data-bound properties.It is invoked only once when the
   * directive is instantiated.It is invoked only once when the
   * directive is instantiated.Here it is initializing the cart & customer informations
   * @return {void}
   */
    ngOnInit(): void {
        const METHOD_NAME: string = 'ngOnInit()';
        this.GSMDeposits = this.customer.deposits.filter((GSM) => {
            return GSM.depositType === 'FULL' && GSM.lineType === 'GSM';
        });
        this.MBBDeposits = this.customer.deposits.filter((MBB) => {
            return MBB.depositType === 'FULL' && MBB.lineType === 'MBB';
        });
    }

    ConvertToInt(val) {
        return parseInt(val);
    }

    ngOnChanges(): void {
        const METHOD_NAME: string = 'ngOnChanges()';
        this.sharedService.storeId.subscribe((val: number) => { this.storeId = val; });
    }
    /**
     * Cleanup just before Angular destroys the directive/component.
     * Unsubscribe Observables and detach event handlers to avoid memory leaks.
     * @returns void
     */
    ngOnDestroy(): void {
        const METHOD_NAME: string = 'ngOnDestroy()';
        this.customer = null;
        this.isDepositLinesDisplayed = null;
        this.Math = null;
        this.isDepositLinesDisplayedMI = null;
        this.storeId = null;
    }
}
